import React from 'react'
import Map3 from '../Images/Map3.png'

function MapBanner() {
    return (
        <>
            <section class="p-2 container " style={{ marginTop: "30px" }}>
                <div className='row'>

                    <div className='col-md-6'>
                        <img src={Map3} />
                    </div>

                    <div className='col-md-6'>
                        <h1><b style={{ fontSize: "1.8rem", fontFamily: "poppins" }}>Best income tax e-filing website in India</b></h1>


                        <ul>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>We have changed the way people do tax filing in India. We don’t just get your tax return filed within minutes but get you maximum refunds in shortest time.</li>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>4.8 Star Service Rating</li>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>1+ Million Trusted Users</li>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>Top 25 Emerging Startup of Asia</li>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>Authorized by Income Tax Department</li>
                        </ul>



                        <h3> <b style={{ fontSize: "1.8rem", fontFamily: "poppins", textAlign: "justify" }} >Every member of our team is passionate about taxes. Every month we spend over 2,40,000 hours doing taxes.</b></h3>

                        <ul>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>Authorized by Income Tax Department</li>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>Registered with Startup India (A Govt. of India initiative)</li>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>Supported by iStart (Rajasthan Govt. initiative for startups)</li>
                            <li style={{ textAlign: "justify", fontFamily: "poppins", fontSize: "19px" }}>Supporting government making India Digital</li>
                        </ul>





                    </div>

                </div>
            </section>

        </>
    )
}

export default MapBanner